import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild, } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2'
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { NumberFormatDirective } from 'app/directives/number-format.directive';
import { SettingFieldSalaryComponent } from './setting-field/setting-field-salary.component';
import { Parser } from 'expr-eval';
import { forkJoin } from 'rxjs';
import { FilterModel } from './filter.model';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { BudgetOverViewComponent } from '../../budget-over-view/budget-over-view.component';
import { SettingFieldDepartamentComponent } from '../../departament-account/setting-field-departament/setting-field-departament.component';

@Component({
  selector: 'app-tabulation-salary',
  standalone: true,
  imports: [DecimalPipe, NgSelectModule, FormsModule, NumberFormatDirective, SettingFieldSalaryComponent, SettingFieldDepartamentComponent, NgbModule, CommonModule, BudgetOverViewComponent],
  providers: [NgbModal, { provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './tabulation-salary.component.html',
  styleUrl: './tabulation-salary.component.css'
})
export class TabulationSalaryComponent  {
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('modal_setting', { static: true }) modalSetting: any;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  public dataDepartament;
  public ngSelectedOld: string;
  public inputOld;
  public datalistEmployee: { [key: string]: any[] } = {};
  public accountPlanVersion: { [key: string]: any[] } = {};
  public accountPlanVersionTemp: { [key: string]: any[] } = {};
  public salaryEmployee: { [key: string]: any[] } = {};
  public salaryEmployeeTemp: { [key: string]: any[] } = {};
  public subtotal: { [key: string]: any } = {};
  private entitySelected: Entity;
  public itemsTemp;
  public codeEntity;
  public txtFind;
  public salaryService = inject(BudgetGenerateService)
  public filter: FilterModel = new FilterModel();
  public navTab = 'dependientes'
  public rows =Array.from({length: 15}, (_, i) => i + 1);
  public cols =Array.from({length: 5}, (_, i) => i + 1);
  public isLoading =true;
  public isActiveConfig=false;
  public title='Presupuesto'
  public items;
  public employeeType;
  public budgetEmployeeType;
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  public budgetVersionSelected;
  public activeSettingDepartament=false;
  filterByEmployeeType: { [key: string]: any[] } = {};
  public budgetFund;
  public fundSelect;
  public departamentTemp;
  public selectedDepartament;
  public timeoutUnselect;
  public budgetStatus;

  get isBudgetDisabled(): boolean {
    const status = this.budgetStatus ?? this.budgetVersionSelected?.status;
    if (status === undefined || status === null) {
      return false;
    }
    // Solo está abierto si status === 2 (Proceso). Si es 3 (Finalizado), 4 (Votado) o cualquier otro, está deshabilitado.
    return Number(status) !== 2;
  }

  constructor(private modalService: NgbModal

  ) {


    effect(() => {
      this.entitySelected = this.userService.sharingEntity();

    })
    effect(() => {
      this.budgetVersionSelected = this.userService.sharingBudgetVersion()
      const employeeTypesData = this.userService.sharingEmployeeType();
      const budgetFundData = this.userService.sharingBudgetFund();
      this.budgetEmployeeType = employeeTypesData || [];
      if (this.budgetEmployeeType.length > 0) {
        this.budgetFund = budgetFundData;
        this.fundSelect = budgetFundData[0].fundCode;
        this.filter.year = this.budgetVersionSelected.year;
        this.filter.version = this.budgetVersionSelected.version;
        this.budgetStatus=this.budgetVersionSelected.status       
          this.employeeType = this.budgetEmployeeType?.[0]?.employeeType;
          this.title=this.budgetEmployeeType?.[0]?.employeeTypeName;
          this.syncDepartamentEmployeeCalculated()
      } 
  });
  }

  openAccountConfig() {
    this.isActiveConfig = true;
  }


  tabChange(employeeType) {
    this.employeeType=employeeType.employeeType;
    this.title=employeeType.employeeTypeName;
    this.changeFund(this.fundSelect);
  }

  ngOnInit() {

  }


  changeSettingDepartament(){
    this.activeSettingDepartament=false;
    this.getDepartamentBudgetConfig()
  }

  syncDepartamentEmployeeCalculated(){
    let filter={...this.filter};
    this.salaryService.syncDepartamentEmployeeCalculated(filter).subscribe(res => { 
      this.getAccountPlanVersion()
      this.getDepartamentBudgetConfig()
      this.getDepartamentAccountEmployee()
      this.getResumen(); 
    })
  }


    /**trae los datos de los departamentos de la cuenta seleccionada */
    getDepartamentBudgetConfig() {
      let filter={...this.filter};
      filter.typeId=411;
      this.salaryService.getDepartamentBudgetConfig(filter).subscribe(res => { 
       this.departamentTemp=JSON.parse(JSON.stringify(res)); 
       this.changeFund(this.fundSelect);
        Swal.close()
      })
    }


    openModalSettingDepartament() {
      this.activeSettingDepartament=true;
    }
  


    /**al momento de cerrar el ng select de busqueda busca actualiza la tabla de diversos  */
changeNgSelectFilter(employeeType) {
  const filters = this.filterByEmployeeType[employeeType];

  if (!filters || filters.length === 0) {
    this.salaryEmployee[employeeType] = this.salaryEmployeeTemp[employeeType];
  } else {
    this.salaryEmployee[employeeType] = this.salaryEmployeeTemp[employeeType].filter(d => 
      filters.includes(d.employeeCode)
    );
  }

  this.buildSubtotal();
}
    

  getResumen() {
    let filter={...this.filter};
    this.salaryService.getResumen(filter).subscribe(res => {
      this.itemsTemp=JSON.parse(JSON.stringify(res));    
      this.items = res;    
      this.changeFund(this.fundSelect);
    })
  }



  changeSetting() {
   this.getAccountPlanVersion();
   this.getDepartamentAccountEmployee();
   this.getResumen();
  }

  openModalAccount() {
    this.open(this.modalAccount, { size: 'xl' })
  }

  openModalSetting() {
    this.open(this.modalSetting)
  }

  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  /**Selecciona todo el texto del input */
  selectAll(event: Event,employee) {
    if (this.timeoutUnselect) {
      clearTimeout(this.timeoutUnselect);
      this.timeoutUnselect = null;
    } 
    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
    if(this.entitySelected?.group!='IASD'){

      const departament=this.departamentTemp.find(d=>d.departamentCode==employee.departamentCode);
      this.selectedDepartament = departament;
    }
  }

  unSelectedDepartamentCode(){
    if(this.entitySelected?.group!='IASD'){
    this.timeoutUnselect = setTimeout(() => {
      
      this.selectedDepartament = undefined;
    }, 200);
  }
  }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }


    // Obtiene el valor de una cuenta
    getSubtotalValue(code, employeeType) {
     // console.log(this.subtotal);
//console.log(code, employeeType);
//console.log(this.subtotal[employeeType]?.[code]);
      if(this.subtotal[employeeType]?.[code]){        
      
      let account = this.subtotal[employeeType]?.[code];
      return account ? account : null;
      }
      return 0;
    }

    

  buildSubtotal() {
    this.subtotal = {};
  
    this.budgetEmployeeType.forEach(b => {
      const employees = this.salaryEmployee[b.employeeType] ?? [];
      const summary = {};
      employees.forEach(emp => {
        this.calculatedSubtotal(emp, summary);
       
      });
      this.subtotal[b.employeeType] = summary;
    });
  }


calculatedSubtotal(emp, summary) {
  emp.accounts.forEach(account => {    
    if (account.isTaxable) {
      const accountValue=Number(account.value);
      const validValue = isNaN(accountValue) ? 0 : accountValue;
      summary['total']=(summary['total']??0)+validValue;
      if (!summary[account.accountCode]) summary[account.accountCode] = 0;
      summary[account.accountCode] += validValue;
    }
  });
}


      /*filtra los datos por fund*/

      changeFund(fundCode) {
        this.fundSelect=fundCode;
        if(this.salaryEmployeeTemp[this.employeeType]&&this.departamentTemp){
        this.salaryEmployee[this.employeeType] = this.salaryEmployeeTemp[this.employeeType]?.filter(d => 
          d.fundCode==this.fundSelect
        );
        this.datalistEmployee[this.employeeType] = this.ngSelectDiverse(this.salaryEmployee[this.employeeType]);
        this.changeFundDepartament();
        this.changeFundPlan();
        this.changeFundResumen();
        this.changeNgSelectFilter(this.employeeType);
      }
    }

  changeFundDepartament() {
    if(this.departamentTemp){
      const dataDepartament = this.departamentTemp?.filter(d => 
        d.fundCode==this.fundSelect&&d.employeeType==this.employeeType||this.entitySelected.group!='IASD'
      );
      this.dataDepartament=this.ngSelectDepartament(dataDepartament);
    }
  }

    
  changeFundResumen() {
    if(this.itemsTemp){
      Object.keys(this.itemsTemp).forEach(key => {
        const arr = this.itemsTemp[key];
        
        if (Array.isArray(arr) && arr.length > 0 && 'fundCode' in arr[0]) {
          this.items[key] = arr.filter(item => item.fundCode == this.fundSelect);
        }
      });
    }
   this.items={...this.items}
  }

    changeFundPlan() {
       this.accountPlanVersion[this.employeeType]=this.accountPlanVersionTemp[this.employeeType]?.filter(d => 
        d.fundCode==this.fundSelect
      );
    }



   updateValueSalary(employee, input, newValue, employeeType) {
     if (this.isBudgetDisabled) {
       return;
     }
     const currentValue = employee[input];
     employee[input] = newValue;
      let account = this.setEmployeeAccount(employee, input);
      if (account) {
        account.value = newValue;
      }
      this.salaryService.updateSalaries(employee).subscribe({
        next: (res) => { 
          this.getResumen();
          this.notification('Actualizado');
        },
        error: (err) => {
          console.error('Error al actualizar salario:', err);
          Swal.fire({
            icon: 'error',
            title: 'Presupuesto no editable',
            text: err.error?.error || err.error?.message || 'El presupuesto no está abierto.'
          });
          this.getDepartamentAccountEmployee();
        }
      });
    }
  


   updateDepartamentEmployee(id, event) {
    if (this.isBudgetDisabled) {
      return;
    }
    const departamentFundCode = event.departamentFundCode;
    const departamentCode = event.departamentCode;
    const employee = this.salaryEmployee[this.employeeType]?.find(e => e.id == id);
    if (employee) {
      employee.departamentFundCode = departamentFundCode;
      employee.departamentCode = departamentCode;
    }
    this.salaryService.updateDepartamentEmployee({ id: id, departamentFundCode: departamentFundCode, departamentCode: departamentCode }).subscribe({
      next: () => {
        this.getResumen();
      },
      error: (err) => {
        console.error('Error al actualizar departamento del empleado:', err);
        Swal.fire({
          icon: 'error',
          title: 'Presupuesto no editable',
          text: err.error?.error || err.error?.message || 'El presupuesto no está abierto. Solo se permiten modificaciones en estado Proceso (Abierto).'
        });
        this.getDepartamentAccountEmployee();
      }
    });
  }

  getSelectedDepartament(employee) {
    let result = this.dataDepartament?.find(d => 
      d.departamentCode === employee.departamentCode &&
      d.departamentFundCode ===employee.departamentFundCode
    );
    return result;
  }


getTotalEmployee(employee: any): number {
  if (!employee?.accounts) return 0;
  return employee.accounts.reduce((acc, a) => acc + (Number(a.value) || 0), 0);
}
  


  updateValueAccounts(employee, accountCode, value, employeeType) {
    if (this.isBudgetDisabled) {
      return;
    }
    value = value.replace(/\./g, '').replace('.', ',');
    const account = this.setEmployeeAccount(employee, accountCode);
    if (account) {
      account.value = value;
    }
    this.salaryService.updateDepartamentAccountEmployee({ id: account?.id, value: value }).subscribe({
      next: (res) => {
        this.getResumen();
        this.notification('Actualizado');
      },
      error: (err) => {
        console.error('Error al actualizar cuenta:', err);
        Swal.fire({
          icon: 'error',
          title: 'Presupuesto no editable',
          text: err.error?.error || err.error?.message || 'El presupuesto no está abierto. Solo se permiten modificaciones en estado Proceso (Abierto).'
        });
        this.getDepartamentAccountEmployee();
      }
    });
  }

  // Busca el valor de una cuenta específica dentro del array de cuentas de un empleado.  
  findEmployeeAccountValue(employeeAccount, code) {
    let value = 0;
    if (Array.isArray(employeeAccount)) {
      let account = employeeAccount.find(acc => acc.accountCode == code);
      if (account) {
        value = account.value;
      }
    }
    return value
  }


 





  setEmployeeAccount(employee, accountCode) {
     const result = employee.accounts?.find(acc => acc.accountCode == accountCode);
    return result;
  }




  // Obtiene el valor de una cuenta
  getAccountValue(employee, accountCode) {
    return this.findEmployeeAccountValue(employee.accounts, accountCode);
  }



  /**trae los datos de los dependientes */

 getDepartamentAccountEmployee() {
    this.loading();
    this.salaryService.getDepartamentAccountEmployee(this.filter).subscribe(res => {
      this.budgetEmployeeType.forEach(b => {
        const list = res.filter(r => r.employeeType=== b.employeeType);
        this.salaryEmployee[b.employeeType] = list;
        this.salaryEmployeeTemp[b.employeeType] = JSON.parse(JSON.stringify(list));
        this.datalistEmployee[b.employeeType] = this.ngSelectDiverse(list); 
      });      
      this.isLoading =false;
      this.changeFund(this.fundSelect);
      Swal.close()
    })
  }




  

  /**trae los departamentos */
  getAasinetDepartament() {
    this.salaryService.getAasinetDepartament().subscribe(res => {
      this.dataDepartament = this.ngSelectDepartament(res);
    })
  }




  /*al momento de dar un click almacena el valor anterior del input en otra funcion se compara el valor nuevo con el anterior */
  toggleInput(value) {
    this.inputOld = value.replace(/\./g, '').replace('.', ',');
  }


  /**Mapea los datos en formato valido para ngSelect */
  ngSelectDepartament(data) {
    let newData = data.map((d) => {
      return {
        departamentCode: d.departamentCode.toString(),
        codeName: d.departamentCode + ' - ' + d.displayName,
        name: d.displayName,
        departamentFundCode: d.departamentFundCode,
      }
    });
    return newData
  }


  /*mapea los datos del ng-select */
  ngSelectDiverse(diverse) {
    let newData = diverse.map((d) => {
      return {
        code: d.employeeCode,
        codeName: d.employeeCode + ' - ' + d.names,
        name: d.names
      }
    });
    return newData
  }





  /**trae el plan de cuentas */
  getAccountPlanVersion() {
    this.salaryService.getSalaryPlanVersion(this.filter).subscribe(res => {
      this.budgetEmployeeType.forEach(b => {
        const list = res.filter(r => r.employeeType==b.employeeType &&r.isActive);
        this.accountPlanVersionTemp[b.employeeType] = JSON.parse(JSON.stringify(list));
        this.accountPlanVersion[b.employeeType] = list;
        this.changeFund(this.fundSelect);
      });
    })
  }

  /*mensaje de cargando */
  loading() {
    Swal.fire({
      title: 'Cargando...',
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }


  /**exporta a excel */

  headers(typeId){
    let headers = [   
      'N° Diverso',
      'Nombre Empleado',         
      'Departamento',
      'Año',
      'Versión'
    ];
    const accountPlan=this.accountPlanVersion[typeId];
    return [...headers,...this.headerAccounts(accountPlan)]
  }

  headerAccounts(accountPlan){
        return accountPlan.map(acc=>{ 
          const account=acc.accountType!=2?acc.displayName+'('+acc.accountCode+')':'';
          return account
    })
  }

  styleHeaderRow(worksheet, rowNumber: number): void {
    const headerRow = worksheet.getRow(rowNumber);
    worksheet.getRow(rowNumber).height = 25;
    headerRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFBFBFBF' } // gris claro
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium' },
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' }
      };
    });
  }

  styleDataRow(row, accountStartIndex): void {
    row.eachCell((cell, colNumber) => {
      // Aplicar bordes a todas las celdas
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'medium' },
        right: { style: 'medium' }
      };
  
      // Si la columna es una cuenta, aplicar formato numérico
      if (colNumber >= accountStartIndex) {
        cell.numFmt = '#,##0'; // Formato con separador de miles
      }
    });
  }


  autoAdjustColumns(worksheet): void {
    worksheet.columns.forEach(column => {
      let max = 10;
      column.eachCell({ includeEmpty: true }, cell => {
        const len = cell.value ? cell.value.toString().length : 10;
        if (len > max) max = len;
      });
      column.width = max + 2;
    });
  }  


  
styleSubtotalRows(worksheet, rowNumber: number): void {
  const subtotalRow = worksheet.getRow(rowNumber);
  subtotalRow.height = 25;
  subtotalRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFBFBFBF' } // gris claro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'right' };
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
    cell.numFmt = '#,##0';
  });
}


addSubtotalRow(worksheet,startCol,rowNumber,mergeCol): void {
  const lastRowNumber = worksheet.lastRow.number;
  const subtotalRow = worksheet.addRow([]);
  if (mergeCol >= 1) {
    worksheet.mergeCells(subtotalRow.number, 1, subtotalRow.number, mergeCol);
    const labelCell = worksheet.getCell(subtotalRow.number, 1);
    labelCell.value = 'SUBTOTAL';
    labelCell.alignment = { horizontal: 'center', vertical: 'middle' };
    labelCell.font = { bold: true };
  }
  for (let col = startCol; col <= worksheet.columnCount; col++) {
    const colLetter = worksheet.getColumn(col).letter;
    const cell = subtotalRow.getCell(col);
    cell.value = {
      formula: `SUM(${colLetter}${rowNumber}:${colLetter}${lastRowNumber})`,
      result: null
    };
    cell.font = { bold: true };
  }
}
  


  createSheet(workbook: Workbook, title, headers, data, accounts) {
    const totalColumns = 6 + accounts.length;
    const worksheet = workbook.addWorksheet(title);
  
    // Título
    worksheet.mergeCells(1, 1, 1, totalColumns);
    const titleCell = worksheet.getCell('A1');
    titleCell.value = `SUELDO ${title.toUpperCase()}`;
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.font = { bold: true };
    worksheet.getRow(1).height = 40;
    for (let col = 1; col <= totalColumns; col++) {
      worksheet.getCell(1, col).border = {
        top: { style: 'medium' },
        left: { style: 'medium' },
        bottom: { style: 'medium' },
        right: { style: 'medium' },
      };
    }
  
    // Encabezados: nombres de cuentas
    worksheet.mergeCells(2, 1, 2, 6);
    worksheet.getCell('A2').value = 'Departamentos \\ cuentas';
    worksheet.getCell('A2').alignment = { horizontal: 'center', vertical: 'middle' };
    accounts.forEach((acc, index) => {
      worksheet.getCell(2, 7 + index).value = acc.display_name;
    });
  
    // Encabezado principal
    worksheet.addRow(headers);
    this.styleHeaderRow(worksheet, 2);
    this.styleHeaderRow(worksheet, 3);
    // Datos
    data.forEach(obj => {
      const row = worksheet.addRow(Object.values(obj));
      this.styleDataRow(row, 7);
    });
    this.addSubtotalRow(worksheet,6,4,6);
    this.styleSubtotalRows(worksheet, worksheet.lastRow.number-1);
    
  
    this.autoAdjustColumns(worksheet);
  }
  
  //negative
negative(event: KeyboardEvent){
  const charCode = event.which ? event.which : event.keyCode;
}


coditionalNegativeSymbol(input){
  return input.value.includes('-') || input.selectionStart !== 0
}

setCharCode(event){
  return event.which ? event.which : event.keyCode;
}
  onlyNumber(event: KeyboardEvent) {
    const charCode = this.setCharCode(event)
    const input = event.target as HTMLInputElement;
    if (
      [8, 9, 37, 39, 46, 48,49,50,51,52,53,54,55,56,57].includes(charCode)
    ) {
      return;
    }
  
    // Permitir el signo negativo solo al inicio
    if (charCode === 45) {
      if (this.coditionalNegativeSymbol(input)) {
        event.preventDefault();
      }
      return;
    }
  
  }
  

  exportToExcel(): void {
    const workbook = new Workbook();
  
    for (let b of this.budgetEmployeeType) {
      const employeeType = b.employeeType;
      const data = this.salaryEmployee[employeeType];
      const accounts = this.accountPlanVersion[employeeType];
      const headers = this.headers(b.employeeType);
      const sheetTitle = b.employeeTypeName;
  
      const formattedData = this.dataExcel(data, accounts);
      this.createSheet(workbook, sheetTitle, headers, formattedData, accounts);
    }
  
    // Solo se ejecuta una vez al final
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      this.saveExcelFile(blob, 'sueldos_' + this.getDate());
    });
  }
  

  dataExcel(data,plan) {
    const result = data.map(e => {
      const fixedDataValues = [  
        e.employeeCode,
        e.names,              
        e.departamentName,
        e.year,
        e.version,
      ];  
      const accountsData = this.flattenAccounts(e.accounts);
      const accountsValues = plan.map(code => accountsData[code.accountCode] ?? 0);  
      const result2 = [...fixedDataValues, ...accountsValues];
      return result2
    });
    return result;
  }
  
  flattenAccounts(accounts) {
    const accountMap = {};
    for (const acc of accounts) {
      accountMap[acc.accountCode.toString()] = Number(acc.value) ?? 0; 
    }
    return accountMap;
  }
  

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }

    /**Obtener la fecha en formato 04/12/2024 09:36:44  */
    getDate() {
      let date = new Date();
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const; // Opciones para la fecha
      const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
      const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Formato HH:mm:ss
      return `${formattedDate}_${formattedTime}`;
    }


}
